export default class GlobalCSS {
  constructor() {
    const style = document.createElement('style')
    style.type = 'text/css'
    document.getElementsByTagName('head')[0].appendChild(style)

    this.sheet = style.sheet
    this.rules = this.sheet[document.all ? 'rules' : 'cssRules']
  }

  updateCSS = (settings) => {
    this.removeRule(
      '.section-inner h1, .section-inner h2, .section-inner h3, .section-inner h4'
    )
    this.removeRule('.section-inner h1')
    this.removeRule('.section-inner h2')
    this.removeRule('.section-inner h3')
    this.removeRule('.section-inner h4')
    this.removeRule('.section-inner p')
    this.removeRule('.section-inner ol, .section-inner ul')
    this.removeRule('.section-inner a:not(.gan-product-link)')
    this.removeRule('.section-inner .underline a:not(.gan-product-link)')
    this.removeRule('.section-inner [style$="underline;"] a:not(.gan-product-link)')

    const h1FontSize = +settings.headings_h1FontSize
    const h2FontSize = +settings.headings_h2FontSize
    const h3FontSize = +settings.headings_h3FontSize
    const h4FontSize = +settings.headings_h4FontSize
    const normalTextFontSize = +settings.normalText_fontSize

    this.addRule(
      '.section-inner h1, .section-inner h2, .section-inner h3, .section-inner h4',
      `color:${settings.headings_color};font-weight:${settings.headings_fontWeight};font-family:${settings.headings_fontFamily}`
    )
    this.addRule(
      '.section-inner h1',
      `line-height:${settings.headings_lineHeight};font-size:${h1FontSize}px;`
    )
    this.addRule(
      '.section-inner h2',
      `line-height:${settings.headings_lineHeight};font-size:${h2FontSize}px;`
    )
    this.addRule(
      '.section-inner h3',
      `line-height:${settings.headings_lineHeight};font-size:${h3FontSize}px;`
    )
    this.addRule(
      '.section-inner h4',
      `line-height:${settings.headings_lineHeight};font-size:${h4FontSize}px;`
    )
    this.addRule(
      '.section-inner p',
      `line-height:${settings.normalText_lineHeight};font-size:${normalTextFontSize}px;`
    )
    this.addRule(
      '.section-inner ol, .section-inner ul',
      `line-height:${settings.normalText_lineHeight};font-size:${normalTextFontSize}px;padding: 0 0 0 20px;list-style-position: outside;`
    )
    this.addRule('.section-inner a:not(.gan-product-link)', `color:${settings.link_color}`)
    this.addRule('.section-inner .underline a:not(.gan-product-link)', `text-decoration: underline;`)
    this.addRule('.section-inner [style$="underline;"] a:not(.gan-product-link)', `text-decoration: underline;`)
  }

  removeRule = (rule) => {
    let val

    do {
      val = Array.prototype.findIndex.call(
        this.rules,
        (item) => item.selectorText === rule
      )
      if (val > -1) {
        if (typeof this.sheet.deleteRule === 'function') {
          this.sheet.deleteRule(val)
        } else {
          this.sheet.removeRule(val)
        }
      }
    } while (val > -1)
  }

  addRule = (selectorText, value) => {
    if (typeof this.sheet.insertRule === 'function') {
      // W3C model
      this.sheet.insertRule(
        selectorText + ' {' + value + '}',
        this.sheet.cssRules.length
      )
    } else if (this.sheet.addRule) {
      // IE model
      this.sheet.addRule(selectorText, value, this.sheet.rules.length)
    }
  }
}
